import { Stack } from "@mui/material";
import React from "react";
import AccessCode from "./AccessCode";
import {
  ContainedButtonWithForwardArrow,
  LocationNPI,
  PrimaryFormHelperText,
} from "react-common-ui-library";
import {
  ACCESS_CODE_HELPER_TEXT_ID,
  NEXT_STEP_BUTTON_ID,
} from "../../../Constants/ConfirmSiteAccessConstants";
import { useIntl } from "react-intl";
import PropTypes from "prop-types";
import { NEXT_STEP, SUBMIT } from "../../../Constants/CommonConstants";

/**
 * @description Confirm Site access form component which has fields that are part of confirm site access.
 * @param {Boolean} showError flag to show error
 * @param {errorMessage} errorMessage intl id for the error message
 * @returns {ReactNode} Entire form data for confirm site access
 */
const ConfirmSiteAccessForm = ({ showError, errorMessage }) => {
  const intl = useIntl();
  return (
    <Stack spacing={showError ? { xs: 3, md: 3 } : { xs: 4, md: 8 }}>
      <Stack spacing={{ xs: 3, md: 4 }}>
        <AccessCode />
        <LocationNPI />
      </Stack>
      <Stack spacing={{ xs: 4, md: 8 }}>
        {showError ? (
          <PrimaryFormHelperText
            helperTextId={ACCESS_CODE_HELPER_TEXT_ID}
            error={true}
            helperText={intl.formatMessage({
              id: errorMessage,
            })}
          />
        ) : null}
        <ContainedButtonWithForwardArrow type={SUBMIT} id={NEXT_STEP_BUTTON_ID}>
          {intl.formatMessage({ id: NEXT_STEP })}
        </ContainedButtonWithForwardArrow>
      </Stack>
    </Stack>
  );
};

export default ConfirmSiteAccessForm;

ConfirmSiteAccessForm.defaultProps = {
  errorMessage: "",
};

ConfirmSiteAccessForm.propTypes = {
  showError: PropTypes.bool.isRequired,
  errorMessage: PropTypes.string,
};
